import { filter } from 'lodash';
import React, { useEffect, useState, useCallback } from 'react';
import useStyles from './styles';
import { useTheme } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import TableToolbox from '../../components/TableToolbox';
import CustomizedTooltips from '../../components/CustomizedTooltips';
import { Strings } from '../../utils/strings';
import Tabs from '../../components/Tabs';
import {
  Avatar,
  AvatarGroup,
  Grid,
  Hidden,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  useMediaQuery,
} from '@mui/material';
import EnhancedTableHead from '../../components/DataTables/TableHead';
import {
  getDateRangeValue,
  getErrorMessage,
  isAdmin,
  isClient,
  isSuperAdmin,
  issuesDetailTabArray,
  issuesDetailTabArrayClient,
  secondaryTableCell,
  statusColor,
  tableCell,
  userId,
} from '../../utils/appUtils';
import classNames from 'classnames';
import ActionMenu from './ActionMenu';
import NewIssue from './NewIssue';
import IssuesFilter from './IssuesFilter';
import { connect } from 'react-redux';
import {
  fetchIssueList,
  setIssueList,
} from '../../redux/actions/jobActions/issuesActions/issueList';
import { CircularProgress } from '@material-ui/core';
import moment from 'moment';
import AssignUserDialog from './AssignUserDialog';
import { icons } from '../../utils/icons';
import CommonDialog from '../../components/CommonDialog';
import { deleteIssue } from '../../redux/actions/jobActions/issuesActions/deleteIssue';
import { updateIssueByPerformAction } from '../../redux/actions/jobActions/issuesActions/updateIssueByPerformAction';
import { sendUpdate } from '../../redux/actions/jobActions/issuesActions/sendUpdate';
import { useAlert } from 'react-alert';
import AddNotes from './NotesDialog';
import TitleContainer from '../../components/TitleContainer';
import Button from '../../components/Button';
import ActionDrawer from './ActionDrawer';
import ActionButton from './ActionButton';
import MediaImageContainer from '../../components/MediaImageContainer';
import NewJob from '../Jobs/NewJob';
import { visibleIssue } from '../../redux/actions/jobActions/issuesActions/visibleIssue';
import { deleteIssueNote } from '../../redux/actions/jobActions/issuesActions/deleteIssueNote';
import { clientDirectiveReminder } from '../../redux/actions/jobActions/issuesActions/clientDirectiveReminder';
import debounce from 'lodash/debounce';
import SendReport from '../Jobs/SendReport';
import { listFilter } from '../../redux/actions/filterActions/listFilter';
import IssuesNewFilter from './IssuesFilter/IssuesNewFilter';
import { markAllIssuesNotesRead } from '../../redux/actions/jobActions/issuesActions/markAllIssuesNotesRead';
import { exportIssues } from '../../redux/actions/commonActions/exportIssues';
import { useDispatch } from 'react-redux';
import { setAddIssueNote } from '../../redux/actions/clientActions/addIssueNote';
import { setUpdateIssueNote } from '../../redux/actions/jobActions/issuesActions/updateIssueNote';

const filterStore = 'IssuesFilter';

// ======== Table Head =========
const headCells = () => {
  return !isClient()
    ? [
        { id: 'issueTitle', label: 'ISSUE TITLE', isSort: true },
        // { id: 'client', label: 'CLIENT', isSort: true },
        { id: 'property', label: 'PROPERTY', isSort: true },
        { id: 'type', label: 'TYPE', isSort: true },
        { id: 'category', label: 'CATEGORY', isSort: true },
        { id: 'dueDate', label: 'NEXT STEP DUE', isSort: true },
        { id: 'priority', label: 'PRIORITY', isSort: true },
        // { id: 'assigned', label: 'ASSIGNED' },
        { id: 'status', label: 'STATUS', isSort: true },
        { id: 'vendor', label: 'VENDOR' },
        // { id: 'homeOwnerDirective', label: 'HOME OWNER DIRECTIVE' },
        { id: '' },
      ]
    : [
        { id: 'issueTitle', label: 'ISSUE TITLE', isSort: true },
        { id: 'property', label: 'PROPERTY', isSort: true },
        { id: 'type', label: 'TYPE', isSort: true },
        { id: 'category', label: 'CATEGORY', isSort: true },
        // { id: 'dueDate', label: 'DUE DATE', isSort: true },
        { id: 'status', label: 'STATUS', isSort: true },
        { id: 'vendor', label: 'VENDOR' },
        { id: '' },
      ];
};

const NotesDataList = (props) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <div
      style={{
        borderBottom: !props.isBottomBorder && 'none',
        ...props.style,
      }}
    >
      <div className={classes.flex_row}>
        <p className={classes.note_data} style={{ border: 0 }}>
          {props.data}
        </p>
        {props?.createdBy?._id === userId() && !isClient() && (
          <div className={classes.flex_row} style={{ marginLeft: 'auto' }}>
            <CustomizedTooltips title={Strings.EDIT_NOTE}>
              <img
                className={classes.action_icons}
                src={icons(theme).editIcon}
                alt=''
                onClick={() => props.onEditClick()}
              />
            </CustomizedTooltips>
            {props?.showLoader ? (
              <CircularProgress
                style={{
                  color: theme.palette.background_button,
                  marginLeft: 15,
                }}
                size={20}
              />
            ) : (
              <CustomizedTooltips title={Strings.DELETE_NOTE}>
                <img
                  className={classes.action_icons}
                  src={icons(theme).deleteIcon}
                  alt=''
                  onClick={() => props.onDeleteClick()}
                  style={{ marginLeft: 15 }}
                />
              </CustomizedTooltips>
            )}
          </div>
        )}
      </div>
      {props.createdBy && (
        <div className={classes.note_details_container}>
          <p
            className={classes.note_data}
            style={{ paddingBottom: 0, marginBottom: 0 }}
          >
            <span style={{ fontWeight: 600 }}>{Strings.CREATED_BY}: </span>
            {`${props.createdBy.name} ( ${
              moment(props.createdAt).format('ll') + // LL - Jul 14, 2023
              ' ' +
              moment(props.createdAt).format('LT')
            } )`}
          </p>
        </div>
      )}
    </div>
  );
};

function descendingComparator(a, b, orderBy) {
  let asceding = b[orderBy] < a[orderBy];
  let descding = b[orderBy] > a[orderBy];
  if (orderBy === 'issueTitle') {
    asceding = b[orderBy]?.toLowerCase() < a[orderBy]?.toLowerCase();
    descding = b[orderBy]?.toLowerCase() > a[orderBy]?.toLowerCase();
  } else if (orderBy === 'client') {
    asceding =
      b[orderBy]?.lastName.toLowerCase() < a[orderBy]?.lastName.toLowerCase();
    descding =
      b[orderBy]?.lastName.toLowerCase() > a[orderBy]?.lastName.toLowerCase();
  } else if (orderBy === 'property') {
    asceding = b[orderBy]?.name.toLowerCase() < a[orderBy]?.name.toLowerCase();
    descding = b[orderBy]?.name.toLowerCase() > a[orderBy]?.name.toLowerCase();
  } else if (orderBy === 'dueDate') {
    asceding = moment(b[orderBy]) < moment(a[orderBy]);
    descding = moment(b[orderBy]) > moment(a[orderBy]);
  } else {
    asceding = b[orderBy] < a[orderBy];
    descding = b[orderBy] > a[orderBy];
  }

  if (asceding) {
    return -1;
  }
  if (descding) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(order, orderBy, array, comparator) {
  if (!['priority', 'status'].includes(orderBy)) {
    const stabilizedThis = array?.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  } else if (orderBy === 'priority') {
    const priorities = {
      Low: 1,
      Medium: 2,
      High: 3,
      Critical: 4,
    };
    let sorted = array.sort(function (a, b) {
      if (order === 'asc') {
        return priorities[b.priority] - priorities[a.priority];
      } else {
        return priorities[a.priority] - priorities[b.priority];
      }
    });
    return sorted;
  } else if (orderBy === 'status') {
    const priorities = {
      New: 1,
      'In Progress': 2,
      "Requested Client's Input": 3,
      'Team Discussion Needed': 4,
      'Waiting on Vendor': 5,
      Completed: 6,
      Cancelled: 7,
    };
    let sorted = array.sort(function (a, b) {
      if (order === 'asc') {
        return priorities[b.status] - priorities[a.status];
      } else {
        return priorities[a.status] - priorities[b.status];
      }
    });
    return sorted;
  }
}

const Issues = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const alert = useAlert();

  const [search, setSearch] = useState('');
  // const [issueData, setIssueData] = useState([]);
  const issueData = props.issueListData;
  const exceptClientIssueData = (issueData && issueData.issues) || [];
  const clientIssueData = (issueData && issueData.issues) || [];
  const tempIssues = isClient() ? clientIssueData : exceptClientIssueData;
  const issues = tempIssues || [];
  const [openRows, setOpenRows] = useState([]);
  const [newIssueDialog, setNewIssueDialog] = useState(false);
  const [filterDialog, setFilterDialog] = useState(false);
  const [addNoteDialog, setAddNoteDialog] = useState(false);
  const [assignUserDialog, setAssignUserDialog] = useState(false);
  const [activeTab, setActiveTab] = useState(isClient() ? 'All' : 'all');
  const [deleteIssueDialog, setDeleteIssueDialog] = useState(false);
  const [selectedIssue, setSelectedIssue] = useState({});
  const [selectedIssueId, setSelectedIssueId] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const [filter, setFilter] = useState(
    isAdmin() ? { showAllIssue: false } : null
  );
  const [detailsActiveTab, setDetailsActiveTab] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const mobileView = useMediaQuery(theme.breakpoints.down('sm'));
  const tabletView = useMediaQuery(theme.breakpoints.down('md'));
  const laptopView = useMediaQuery(theme.breakpoints.down('lg'));
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');
  const [addJobDialog, setAddJobDialog] = useState(false);
  const [selectedJob, setSelectedJob] = useState({});
  const [isClientDirective, setIsClientDirective] = useState({});
  const [isEditIssueNote, setIsEditIssueNote] = useState(false);
  const [selectedNote, setSelectedNote] = useState(null);
  const [selectedNoteId, setSelectedNoteId] = useState(null);
  const [openSendReportDialog, setOpenSendReportDialog] = useState(false);
  const [selectedIssueClient, setSelectedIssueClient] = useState('');
  const [filterDropdownValue, setFilterDropdownValue] = useState('0');
  const [filterDropdownList, setFilterDropdownList] = useState([]);
  const [openEditFilterDialog, setOpenEditFilterDialog] = useState();
  const [filterDataList, setFilterDataList] = useState();
  const [isFilterChange, setIsFilterChange] = useState(false);

  const { state } = useLocation();
  const dispatch = useDispatch();

  const tabsArray = [
    { id: 'all', name: 'ALL', length: issueData?.all || 0 },
    {
      id: 'pastDue',
      name: 'PAST DUE',
      length: issueData?.pastDue || 0,
    },
    {
      id: 'dueToday',
      name: 'DUE TODAY',
      length: issueData?.dueToday || 0,
    },
    {
      id: 'dueWeek',
      name: 'DUE THIS WEEK',
      length: issueData?.dueWeek || 0,
    },
    {
      id: 'Critical',
      name: 'CRITICAL',
      length: issueData?.critical || 0,
    },
  ];

  const tabsArrayClient = [
    { id: 'All', name: 'ALL', length: issueData?.all || 0 },
    { id: 'Open', name: 'OPEN', length: issueData?.open || 0 },
    { id: 'Completed', name: 'COMPLETED', length: issueData?.completed || 0 },
  ];

  const onOpenRow = (rowIndex) => {
    if (openRows.findIndex((item, index) => item === rowIndex) === -1) {
      setOpenRows([...openRows, rowIndex]);
    } else {
      setOpenRows(openRows.filter((item) => item !== rowIndex));
    }
  };

  const onError = (err) => {
    const error = getErrorMessage(err);
    if (error) {
      alert.error(error);
    }
  };

  const onSuccess = (msg) => {
    if (msg) {
      alert.success(msg);
    }
  };

  const getIssueList = (search, data) => {
    if (isClient()) data.tab = activeTab;
    props.fetchIssueList(
      'issues',
      search,
      (err) => onError(err),
      activeTab,
      data
    );
  };

  const delayedSearch = useCallback(
    debounce((search, type, data) => {
      props?.fetchIssueList(
        'issues',
        search,
        (err) => onError(err),
        type,
        data
      );
    }, 600),
    []
  );

  useEffect(() => {
    let data = {};
    const storedFilter = localStorage.getItem(filterStore) || {};
    let prevFilter =
      Object.keys(storedFilter).length > 0 ? JSON.parse(storedFilter) : {};
    if (prevFilter && (prevFilter?.filterId || prevFilter?.filter)) {
      if (prevFilter?.filterId) {
        setFilterDropdownValue(prevFilter?.filterId || '0');
      }
      if (prevFilter?.filter) {
        if (prevFilter?.filter?.dateRange !== 'All Time') {
          let dateRange = getDateRangeValue(prevFilter?.filter?.dateRange);
          let filter = {
            ...prevFilter?.filter,
            startDate: moment(dateRange.startDate).format('YYYY-MM-DD'),
            endDate: moment(dateRange.endDate).format('YYYY-MM-DD'),
          };
          prevFilter = { filter: { ...filter } };
        }
        data.filter = {
          ...prevFilter?.filter,
        };
        setFilter(prevFilter?.filter);
      }
    } else {
      if (filter) data.filter = filter;
    }
    getIssueList(search, data);
  }, [
    activeTab,
    props.addIssueData,
    props.updateIssueData,
    props.deleteIssueData,
    props.updateIssueByActionData,
  ]);

  // useEffect(() => {
  //   const data = props.issueListData ? props.issueListData : [];
  //   setIssueData(data);
  // }, [props.issueListData]);

  const onDeleteIssue = () => {
    props.deleteIssue(
      selectedIssue._id,
      () => setDeleteIssueDialog(false),
      (err) => onError(err)
    );
  };

  const setFilterData = (data) => {
    if (JSON.stringify(data) === '{}' && filter) {
      setSearch('');
      setFilter(isAdmin() ? { showAllIssue: false } : null);
      getIssueList('', {});
      setFilterDropdownValue('0');
      setFilterDataList('');
    } else if (JSON.stringify(data) !== '{}') {
      setSearch('');
      setFilter(data);
      getIssueList('', { filter: data });
      setFilterDropdownValue('0');
      setFilterDataList('');
    }
    localStorage.setItem(filterStore, JSON.stringify({ filter: data }));
  };

  const handleOnAction = async (action, id, client, issueTitle, data) => {
    if (
      action === 'Marked as Completed' ||
      action === 'Proceed' ||
      action === 'Decline'
    ) {
      const data = {
        status:
          action === 'Proceed'
            ? 'In Progress'
            : action === 'Decline'
            ? 'Cancelled'
            : 'Completed',
      };
      props.updateIssueByPerformAction(id, data, (err) => onError(err));
    } else if (action === 'Send Update') {
      //api call for send update
      // props.sendUpdate(id, onSuccess, onError);
      await setSelectedIssueClient(client?.email);
      await setOpenSendReportDialog(true);
      await setSelectedIssueId(id);
    }
    //  else if (action === `Request Client Directive`) {
    //   //open add note dialog
    //   setIsClientDirective({ id: id, action: `Requested Client's Input` });
    //   setAddNoteDialog(true);
    // } else if (action === `Reminder for client directive`) {
    //   props.clientDirectiveReminder(id, onSuccess, onError);
    // }
    else if (action === 'Assign to an user') {
      setSelectedIssueId(id);
      setAssignUserDialog(true);
    } else if (action === 'Notes') {
      setSelectedIssueId(id);
      setAddNoteDialog(true);
    }
    // else if (action === 'Message to admin') {
    //   navigate('/app/chat', {
    //     state: {
    //       admin: client?.adminAssigned?._id,
    //       issueTitle,
    //     },
    //   });
    // }
    else if (action === 'Create a job') {
      setSelectedJob(data);
      setAddJobDialog(true);
    }
  };

  const setTabNotificationData = () => {
    if (issueData?.issues?.length > 0) {
      const newData = issueData?.issues?.map((el, ind) => {
        let isNotReadInternalNotes =
          el?.internalNotes?.length > 0
            ? el?.internalNotes?.some((elm) => !elm.isRead)
            : false;
        let isNotReadNote =
          el?.notes?.length > 0 ? el?.notes?.some((elm) => !elm.isRead) : false;

        return {
          key: 'details',
          notesNotification: isNotReadNote,
          internalNotesNotification: isNotReadInternalNotes,
        };
      });
      return newData;
    }
  };

  const handleRequestSort = async (event, property) => {
    setOpenRows([]);
    const newData = await setTabNotificationData();
    await setDetailsActiveTab(newData);
    // setDetailsActiveTab(new Array(issues?.length || 0).fill('details'));
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const filteredIssues = applySortFilter(
    order,
    orderBy,
    issues,
    getComparator(order, orderBy)
  );

  useEffect(() => {
    // if (!isClient()) {
    // const newData = [];
    // for (let i = 0; i < issues?.length || 0; i++) {
    //   newData.push(detailsActiveTab[i] ? detailsActiveTab[i] : 'details');
    // }
    if (issues?.length > 0) {
      const newData = setTabNotificationData();
      setDetailsActiveTab(newData);
    }
    // setDetailsActiveTab(new Array(issues?.length || 0).fill('details'));
    // }
  }, [issueData]);

  const visibleToClient = (issueId, value) => {
    if (issueId) {
      const data = {
        visible: value,
      };
      props.visibleIssue(issueId, data, onError);

      const issueData = props.issueListData;
      const issues = (issueData && issueData.issues) || [];
      const newData = issues.map((item) => {
        if (item._id === issueId) {
          item.visible = value;
        }
        return item;
      });
      issueData.issues = newData;
      dispatch(setIssueList(issueData));
    }
  };

  const onDeleteIssueNoteClick = (iID, nID, nType) => {
    setSelectedNoteId(nID);
    props.deleteIssueNote(iID, nID, nType, onError, () => {
      const newIssueData = props.issueListData;
      const issues = isClient()
        ? newIssueData || []
        : (newIssueData && newIssueData.issues) || [];
      const newData = issues.map((item) => {
        if (item._id === iID) {
          let newIssueNote =
            nType === 'notes'
              ? item?.notes?.filter((el) => el?._id !== nID)
              : item?.internalNotes?.filter((el) => el?._id !== nID);
          item.notes = nType === 'notes' ? newIssueNote : item?.notes;
          item.internalNotes =
            nType === 'internalNotes' ? newIssueNote : item?.internalNotes;
        }
        return item;
      });
      newIssueData.issues = newData;
      dispatch(setIssueList(newIssueData));
      setSelectedNoteId(null);
    });
  };

  useEffect(() => {
    !isFilterChange &&
      props.listFilter(isClient() ? 'ISSUE_CLIENT' : 'ISSUE', onError);
  }, []);

  useEffect(() => {
    if (isFilterChange) {
      const storedFilter = localStorage.getItem(filterStore) || {};
      let prevFilter =
        Object.keys(storedFilter).length > 0 ? JSON.parse(storedFilter) : {};
      if (prevFilter?.filterId) {
        localStorage.removeItem(filterStore);
      }
      props.listFilter(isClient() ? 'ISSUE_CLIENT' : 'ISSUE', onError);
      filterDropdownValue !== '0' &&
        getIssueList('', isAdmin() ? { filter: { showAllIssue: false } } : {});
      setFilter(isAdmin() ? { showAllIssue: false } : null);
      setFilterDropdownValue('0');
      setIsFilterChange(false);
    }
  }, [isFilterChange]);

  useEffect(() => {
    const data = props?.listFilterData?.map((el) => ({
      title: el?.filterName,
      value: el?._id,
      filter: el.filter,
    }));
    setFilterDropdownList(data || []);
  }, [props.listFilterData]);

  const handleFilterSelectionClick = (value) => {
    if (value !== '0') {
      let filterData = filterDropdownList?.filter(
        (el) => el.value === value
      )[0];
      setFilterDataList(filterData?.filter);
      setFilter(filterData?.filter);
      localStorage.setItem(
        filterStore,
        JSON.stringify({
          filter: { ...filterData?.filter },
          filterId: value,
        })
      );
      if (filterData?.filter?.dateRange) {
        const dateRange = getDateRangeValue(filterData.filter.dateRange);
        if (filterData.filter.dateRange !== 'All Time') {
          filterData.filter.startDate = moment(dateRange.startDate).format(
            'YYYY-MM-DD'
          );
          filterData.filter.endDate = moment(dateRange.endDate).format(
            'YYYY-MM-DD'
          );
        }
      }
      setSearch('');
      getIssueList(
        '',
        filterData?.filter ? { filter: filterData?.filter } : {}
      );
    }
  };

  const onClickRefresh = () => {
    let data = {};
    if (filter) data.filter = filter;
    getIssueList(search, data);
  };

  const onClickClearFilter = async () => {
    setSearch('');
    setFilterDropdownValue('0');
    if (isAdmin()) {
      await setFilter({ showAllIssue: false });
      await getIssueList(search, { filter: { showAllIssue: false } });
    } else {
      await setFilter(null);
      await getIssueList(search, {});
    }
    await localStorage.removeItem(filterStore);
  };

  const handleExportIssues = () => {
    let fileName = 'Issue';
    let issueInfo = {};
    if (filter || filterDataList) {
      issueInfo = {
        searchString: search,
        category: activeTab,
        filter: filterDataList ? filterDataList : filter,
      };
    } else {
      issueInfo = {
        searchString: search,
        category: activeTab,
      };
    }
    props.exportIssues(issueInfo, fileName, onError);
  };

  // ===== notification related changes =====
  useEffect(() => {
    if (state && issueData?.issues?.length > 0) {
      const fIndexOfIssue = filteredIssues?.findIndex(
        (el) => el?._id === state.selectedIssue
      );
      const fRowIndex = openRows?.findIndex((el) => el === fIndexOfIssue);
      if (fRowIndex === -1) onOpenRow(fIndexOfIssue);
      if (state?.selectedTab) {
        const newData = setTabNotificationData();
        if (fIndexOfIssue !== -1) {
          newData[fIndexOfIssue].key = state.selectedTab;
          let selectedTabKey =
            state?.selectedTab === 'internal-notes'
              ? 'internalNotesNotification'
              : 'notesNotification';
          newData[fIndexOfIssue][selectedTabKey] = false;
          const data = {
            type:
              state.selectedTab === 'internal-notes'
                ? 'internalNotes'
                : state.selectedTab,
            issueId: state.selectedIssue,
          };
          props.markAllIssuesNotesRead(data, onError);
        }
        setDetailsActiveTab(newData);
      }
      const elem = document.getElementById(state.selectedIssue);
      elem.scroll({ left: 0, top: 0, behavior: 'smooth' });
    }
  }, [state, issueData]);

  // === clear issueList reducer data ===
  useEffect(() => {
    return () => {
      dispatch(setIssueList({}));
    };
  }, []);

  // ==== when add/edit note open selectedIssue and selectedTab ====
  const setAddEditNotes = async (data) => {
    if (data && Object?.keys(data)?.length > 0) {
      const newIssueData = issueData;
      const issues = newIssueData?.issues || [];
      const newData = issues?.map((item) => {
        if (item._id === selectedIssueId) {
          let newIssueNote = [];
          let selectedTabData = data?.internalNotes ? 'internalNotes' : 'notes';
          let itemRemoveArray = data?.internalNotes ? 'notes' : 'internalNotes';
          if (selectedNoteId) {
            let fIndex = item[itemRemoveArray]?.findIndex(
              (el) => el?._id === selectedNoteId
            );
            if (fIndex !== -1) {
              let newNotes = item[itemRemoveArray]?.filter(
                (el) => el?._id !== selectedNoteId
              );
              item[itemRemoveArray] = newNotes;
              newIssueNote = [data, ...item[selectedTabData]];
            } else {
              newIssueNote = item[selectedTabData]?.map((el) => {
                if (el?._id === selectedNoteId) {
                  el.note = data?.note;
                }
                return el;
              });
            }
          } else {
            newIssueNote = [data, ...item[selectedTabData]];
          }
          item.notes = data?.internalNotes ? item?.notes : newIssueNote;
          item.internalNotes = data?.internalNotes
            ? newIssueNote
            : item?.internalNotes;
        }
        return item;
      });
      newIssueData.issues = newData;
      dispatch(setIssueList(newIssueData));
      dispatch(setAddIssueNote(null));
      dispatch(setUpdateIssueNote(null));
      const fIndexOfIssue = filteredIssues?.findIndex(
        (el) => el?._id === selectedIssueId
      );
      const fRowIndex = openRows?.findIndex((el) => el === fIndexOfIssue);
      if (fRowIndex === -1) onOpenRow(fIndexOfIssue);
      const selectedTab = data?.internalNotes ? 'internal-notes' : 'notes';
      const tabNewData = [...detailsActiveTab];
      if (fIndexOfIssue !== -1) {
        tabNewData[fIndexOfIssue].key = selectedTab;
        const data = {
          type:
            selectedTab === 'internal-notes' ? 'internalNotes' : selectedTab,
          issueId: selectedIssueId,
        };
        props.markAllIssuesNotesRead(data, onError);
      }
      setDetailsActiveTab(tabNewData);
      setSelectedNoteId(null);
      setSelectedIssueId('');
    }
  };

  useEffect(() => {
    const data = selectedNoteId
      ? props.updateIssueNoteData || {}
      : props.addIssueNoteData || {};
    if (
      data &&
      issueData?.issues?.length > 0 &&
      (props.addIssueNoteData || props.updateIssueNoteData)
    ) {
      setAddEditNotes(data);
    }
  }, [issueData, props.addIssueNoteData, props.updateIssueNoteData]);

  return (
    <div className={classes.issues_container}>
      <TitleContainer
        containerClassName={classes.title_container}
        title={Strings.ISSUES}
      />
      <TableToolbox
        onClickRefresh={onClickRefresh}
        onClickClearFilter={onClickClearFilter}
        isFilter
        isSearch
        isDownloadCsv={isAdmin() || isSuperAdmin ? true : false}
        isPrimaryButton
        // isPrint={isAdmin() ? true : false}
        search={search}
        onChangeSearch={(e) => {
          const filter = isAdmin() ? { filter: { showAllIssue: false } } : {};
          delayedSearch(e.target.value, activeTab, filter);
          setFilter(isAdmin() ? { showAllIssue: false } : null);
          setSearch(e.target.value);
          setFilterDropdownValue('0');
          // getIssueList(e.target.value, {});
        }}
        searchBoxContainerClassName={classes.searchbox_container_1}
        onNewClick={() => setNewIssueDialog(true)}
        filterButtonClick={() => setFilterDialog(true)}
        onDownloadCsvClick={() =>
          !props.exportIssuesLoading && handleExportIssues()
        }
        downloadCsvLoader={props.exportIssuesLoading}
        toolboxContainerClassName={classes.toolbox_container}
        isFilterDropdown={filterDropdownList.length ? true : false}
        filterDropdownValue={filterDropdownValue}
        filterDropdownList={filterDropdownList}
        onChangeFilterDropdown={(e) => {
          setFilterDropdownValue(e.target.value);
          handleFilterSelectionClick(e.target.value);
          // setFilter({});
        }}
        onEditClick={(value) =>
          setOpenEditFilterDialog({ show: true, ...value })
        }
      />
      {/* {!isClient() && ( */}
      <Tabs
        dataList={isClient() ? tabsArrayClient : tabsArray}
        activeTab={activeTab}
        onChange={(value) => {
          setSearch('');
          setFilter(isAdmin() ? { showAllIssue: false } : null);
          setActiveTab(value);
          setFilterDropdownValue('0');
          localStorage.removeItem(filterStore);
          if (activeTab !== value) setOpenRows([]);
        }}
        containerClassName={classes.tab_container}
      />
      {/* )} */}
      <div className={classes.list_container}>
        {props.issueListLoading ? (
          <div className={classes.flexView}>
            <CircularProgress
              style={{
                color: theme.palette.background_button,
              }}
            />
          </div>
        ) : (
          <>
            {issueData && filteredIssues && filteredIssues.length === 0 ? (
              <div className={classes.flexView}>
                <p className={classes.no_data_message}>
                  {Strings.NO_DATA_FOUND}
                </p>
              </div>
            ) : (
              <TableContainer className='dataTable'>
                <Table
                  className={classes.list_table}
                  aria-labelledby='tableTitle'
                >
                  <Hidden smDown>
                    <EnhancedTableHead
                      handleRequestSort={handleRequestSort}
                      headCells={headCells()}
                      order={order}
                      orderBy={orderBy}
                    />
                  </Hidden>
                  <TableBody>
                    {issueData &&
                      filteredIssues &&
                      filteredIssues.map((data, index) => {
                        const {
                          issueTitle,
                          client,
                          property,
                          type,
                          dueDate,
                          priority,
                          assignedTo,
                          status,
                          vendor,
                          category,
                          // homeOwnerDirective,
                          // issue,
                          notes,
                          description,
                          attachments,
                          _id,
                          createdBy,
                          internalNotes,
                          visible,
                          linkedJobs,
                          suppliesNeeded,
                        } = data;
                        return (
                          <>
                            <TableRow
                              id={data._id}
                              key={data._id}
                              className={classes.row_style}
                              sx={{ width: '100%' }}
                              onClick={() => onOpenRow(index)}
                              onDoubleClick={(e) => {
                                e.preventDefault();
                                setIsEdit(true);
                                setSelectedIssue(data);
                                setNewIssueDialog(true);
                              }}
                            >
                              <Hidden smUp>
                                <TableCell
                                  style={{
                                    ...tableCell(
                                      theme,
                                      openRows.includes(index)
                                    ),
                                  }}
                                  component='td'
                                  scope='row'
                                >
                                  <Stack direction='row' alignItems='center'>
                                    <img
                                      className={classes.toggle_arrow}
                                      src={
                                        openRows.includes(index)
                                          ? icons(theme).downArrow
                                          : icons(theme).rightArrow
                                      }
                                      alt=''
                                      // onClick={() => onOpenRow(index)}
                                    />
                                    <Stack direction='column'>
                                      <label className={classes.name_cell}>
                                        {issueTitle}
                                      </label>
                                      <Stack
                                        paddingTop={1.5}
                                        direction='row'
                                        alignItems='center'
                                      >
                                        {!isClient() && (
                                          <label
                                            className={classes.common_cell}
                                          >
                                            {moment(dueDate).format(
                                              'MMM D, YYYY'
                                            )}
                                          </label>
                                        )}

                                        <label
                                          className={classNames(
                                            classes.common_cell,
                                            isClient()
                                              ? classes.status_container1
                                              : classes.status_container
                                          )}
                                        >
                                          {status}
                                        </label>
                                      </Stack>
                                    </Stack>
                                  </Stack>
                                </TableCell>
                              </Hidden>
                              <Hidden smDown>
                                <TableCell
                                  style={{
                                    ...tableCell(
                                      theme,
                                      openRows.includes(index)
                                    ),
                                  }}
                                  component='td'
                                  scope='row'
                                >
                                  <Stack
                                    paddingTop={2.5}
                                    direction='row'
                                    alignItems='center'
                                  >
                                    <img
                                      className={classes.toggle_arrow}
                                      src={
                                        openRows.includes(index)
                                          ? icons(theme).downArrow
                                          : icons(theme).rightArrow
                                      }
                                      alt=''
                                      // onClick={() => onOpenRow(index)}
                                    />
                                    <label className={classes.name_cell}>
                                      {issueTitle}
                                    </label>
                                  </Stack>
                                </TableCell>
                                {/* {!isClient() && (
                                  <TableCell
                                    style={{
                                      ...tableCell(
                                        theme,
                                        openRows.includes(index)
                                      ),
                                    }}
                                    component='td'
                                    scope='row'
                                  >
                                    <Stack
                                      paddingTop={2.5}
                                      direction='column'
                                      alignItems='flex-start'
                                    >
                                      <label className={classes.common_cell}>
                                        {client?.lastName}
                                      </label>
                                    </Stack>
                                  </TableCell>
                                )} */}
                                <TableCell
                                  style={{
                                    ...tableCell(
                                      theme,
                                      openRows.includes(index)
                                    ),
                                  }}
                                  component='td'
                                  scope='row'
                                >
                                  <Stack
                                    paddingTop={2.5}
                                    direction='column'
                                    alignItems='flex-start'
                                  >
                                    <label className={classes.common_cell}>
                                      {property?.name}
                                    </label>
                                  </Stack>
                                </TableCell>
                                <TableCell
                                  style={{
                                    ...tableCell(
                                      theme,
                                      openRows.includes(index)
                                    ),
                                  }}
                                  component='td'
                                  scope='row'
                                >
                                  <Stack
                                    paddingTop={2.5}
                                    direction='column'
                                    alignItems='flex-start'
                                  >
                                    <label className={classes.common_cell}>
                                      {type}
                                    </label>
                                  </Stack>
                                </TableCell>
                                <TableCell
                                  style={{
                                    ...tableCell(
                                      theme,
                                      openRows.includes(index)
                                    ),
                                  }}
                                  component='td'
                                  scope='row'
                                >
                                  <Stack
                                    paddingTop={2.5}
                                    direction='column'
                                    alignItems='flex-start'
                                  >
                                    <label className={classes.common_cell}>
                                      {category?.categoryName
                                        ? category?.categoryName
                                        : '-'}
                                    </label>
                                  </Stack>
                                </TableCell>

                                {!isClient() && (
                                  <>
                                    <TableCell
                                      style={{
                                        ...tableCell(
                                          theme,
                                          openRows.includes(index)
                                        ),
                                      }}
                                      component='td'
                                      scope='row'
                                    >
                                      <Stack
                                        paddingTop={2.5}
                                        direction='column'
                                        alignItems='flex-start'
                                        style={{ minWidth: 120 }}
                                      >
                                        <label className={classes.common_cell}>
                                          {moment(dueDate).format(
                                            'MMM D, YYYY'
                                          )}
                                        </label>
                                      </Stack>
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        ...tableCell(
                                          theme,
                                          openRows.includes(index)
                                        ),
                                      }}
                                      component='td'
                                      scope='row'
                                    >
                                      {priority && (
                                        <Stack
                                          paddingTop={2.5}
                                          direction='column'
                                          alignItems='flex-start'
                                        >
                                          <label
                                            className={classNames(
                                              classes.common_cell,
                                              classes.status_container,
                                              priority === 'Critical' &&
                                                classes.priority_critical,
                                              priority === 'High' &&
                                                classes.priority_high
                                            )}
                                          >
                                            {priority}
                                          </label>
                                        </Stack>
                                      )}
                                    </TableCell>
                                    {/* <TableCell
                                      style={{
                                        ...tableCell(
                                          theme,
                                          openRows.includes(index),
                                        ),
                                      }}
                                      component='td'
                                      scope='row'
                                    >
                                      <Stack
                                        paddingTop={2.5}
                                        direction='column'
                                        alignItems='flex-start'
                                      >
                                        <AvatarGroup
                                          sx={{
                                            '& .MuiAvatar-root': {
                                              width: 24,
                                              height: 24,
                                              fontFamily:
                                                "'Open Sans', sans-serif",
                                              fontSize: 14,
                                              fontWeight: 400,
                                              border: `1px solid ${theme.palette.background_button_text}`,
                                              color:
                                                theme.palette.profile_title,
                                              backgroundColor:
                                                theme.palette
                                                  .table_head_background,
                                            },
                                          }}
                                          spacing={5}
                                          max={3}
                                        >
                                          {assignedTo.map((item) => (
                                            <Avatar
                                              className={classNames(
                                                classes.common_cell,
                                              )}
                                              alt=''
                                              src={item.profilePicture}
                                            />
                                          ))}
                                        </AvatarGroup>
                                      </Stack>
                                    </TableCell> */}
                                  </>
                                )}
                                <TableCell
                                  style={{
                                    ...tableCell(
                                      theme,
                                      openRows.includes(index)
                                    ),
                                  }}
                                  component='td'
                                  scope='row'
                                >
                                  <Stack
                                    paddingTop={2.5}
                                    direction='column'
                                    alignItems='flex-start'
                                  >
                                    <label
                                      className={classNames(
                                        classes.common_cell,
                                        classes.status_container
                                        // status === 'Active' &&
                                        //   classes.status_active,
                                        // status === 'InActive' &&
                                        //   classes.status_inactive,
                                      )}
                                      style={{
                                        backgroundColor: statusColor(status),
                                      }}
                                    >
                                      {status}
                                    </label>
                                  </Stack>
                                </TableCell>

                                <TableCell
                                  style={{
                                    ...tableCell(
                                      theme,
                                      openRows.includes(index)
                                    ),
                                  }}
                                  component='td'
                                  scope='row'
                                >
                                  <Stack
                                    paddingTop={2.5}
                                    direction='column'
                                    alignItems='flex-start'
                                  >
                                    <label className={classes.common_cell}>
                                      {vendor?.fullName
                                        ? vendor?.fullName
                                        : '-'}
                                    </label>
                                  </Stack>
                                </TableCell>
                                {!isClient() && (
                                  <>
                                    <TableCell
                                      style={{
                                        ...tableCell(
                                          theme,
                                          openRows.includes(index)
                                        ),
                                      }}
                                      component='td'
                                      scope='row'
                                    >
                                      <Stack
                                        paddingTop={2.5}
                                        direction='row'
                                        alignItems='center'
                                        justifyContent='end'
                                        style={{ minWidth: 141 }}
                                      >
                                        <CustomizedTooltips
                                          title={Strings.EDIT_ISSUE}
                                        >
                                          <img
                                            className={classNames(
                                              classes.action_icons,
                                              classes.action_visible,
                                              openRows.includes(index) &&
                                                classes.action
                                            )}
                                            src={icons(theme).editIcon}
                                            alt=''
                                            onClick={(e) => {
                                              e.preventDefault();
                                              e.stopPropagation();
                                              setIsEdit(true);
                                              setSelectedIssue(data);
                                              setNewIssueDialog(true);
                                            }}
                                          />
                                        </CustomizedTooltips>
                                        <CustomizedTooltips
                                          title={
                                            visible
                                              ? Strings.CURRENTLE_VISIBLE_TO_CLIENT
                                              : Strings.CURRENTLE_NOT_VISIBLE_TO_CLIENT
                                          }
                                        >
                                          {props.visibleIssueLoading &&
                                          selectedIssue?._id === _id ? (
                                            <CircularProgress
                                              size={20}
                                              style={{
                                                color:
                                                  theme.palette
                                                    .background_button,
                                                marginLeft: 15,
                                              }}
                                            />
                                          ) : (
                                            <img
                                              className={classNames(
                                                classes.action_icons,
                                                classes.action_visible,
                                                openRows.includes(index) &&
                                                  classes.action
                                              )}
                                              style={{
                                                marginLeft: 15,
                                              }}
                                              src={
                                                visible
                                                  ? icons(theme).eyeIconBlue
                                                  : icons(theme).eyeOffIcon
                                              }
                                              alt=''
                                              onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setSelectedIssue(data);
                                                visibleToClient(
                                                  _id,
                                                  visible ? false : true
                                                );
                                              }}
                                            />
                                          )}
                                        </CustomizedTooltips>
                                        <CustomizedTooltips
                                          title={Strings.DELETEISSUE}
                                        >
                                          <img
                                            className={classNames(
                                              classes.action_icons,
                                              classes.action_visible,
                                              openRows.includes(index) &&
                                                classes.action
                                            )}
                                            style={{
                                              marginLeft: 15,
                                            }}
                                            src={icons(theme).deleteIcon}
                                            alt=''
                                            onClick={(e) => {
                                              e.preventDefault();
                                              e.stopPropagation();
                                              setSelectedIssue(data);
                                              setDeleteIssueDialog(true);
                                            }}
                                          />
                                        </CustomizedTooltips>
                                        <CustomizedTooltips
                                          title={Strings.ADD_NOTE}
                                        >
                                          <img
                                            className={classes.action_icons}
                                            style={{ marginLeft: 15 }}
                                            src={icons(theme).addNote}
                                            alt=''
                                            onClick={(e) => {
                                              e.preventDefault();
                                              e.stopPropagation();
                                              setSelectedIssueId(_id);
                                              setAddNoteDialog(true);
                                            }}
                                          />
                                        </CustomizedTooltips>
                                      </Stack>
                                    </TableCell>
                                  </>
                                )}
                                {isClient() && (
                                  <TableCell
                                    style={{
                                      ...tableCell(
                                        theme,
                                        openRows.includes(index)
                                      ),
                                    }}
                                    component='td'
                                    scope='row'
                                  >
                                    <Stack
                                      paddingTop={2.5}
                                      direction='column'
                                      alignItems='flex-start'
                                    >
                                      <CustomizedTooltips
                                        title={Strings.ADD_NOTE}
                                      >
                                        <img
                                          className={classes.action_icons}
                                          style={{ marginLeft: 15 }}
                                          src={icons(theme).addNote}
                                          alt=''
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setSelectedIssueId(_id);
                                            setAddNoteDialog(true);
                                          }}
                                        />
                                      </CustomizedTooltips>
                                    </Stack>
                                  </TableCell>
                                )}
                              </Hidden>
                              <Hidden smUp>
                                <TableCell
                                  style={{
                                    ...tableCell(
                                      theme,
                                      openRows.includes(index)
                                    ),
                                  }}
                                  component='td'
                                  scope='row'
                                  align='right'
                                >
                                  <Stack
                                    direction='row'
                                    alignItems='center'
                                    justifyContent='end'
                                  >
                                    <CustomizedTooltips
                                      title={Strings.ADD_NOTE}
                                    >
                                      <img
                                        className={classes.action_icons}
                                        src={icons(theme).addNote}
                                        alt=''
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          setSelectedIssueId(_id);
                                          setAddNoteDialog(true);
                                        }}
                                      />
                                    </CustomizedTooltips>
                                  </Stack>
                                </TableCell>
                              </Hidden>
                            </TableRow>
                            {openRows.includes(index) && (
                              <>
                                <TableRow key={data._id} sx={{ width: '100%' }}>
                                  <TableCell
                                    style={{
                                      ...secondaryTableCell(theme, true),
                                    }}
                                    component='td'
                                    scope='row'
                                    colSpan={10}
                                  >
                                    <Grid container>
                                      <Grid item xs={12} sm={10}>
                                        <Stack flexDirection='column'>
                                          <Tabs
                                            underlineTabs
                                            noDataLength
                                            containerClassName={
                                              classes.issue_details_container
                                            }
                                            tabClassName={
                                              classes.issue_details_tab
                                            }
                                            dataList={
                                              isClient()
                                                ? issuesDetailTabArrayClient
                                                : issuesDetailTabArray
                                            }
                                            activeTab={
                                              detailsActiveTab[index]?.key
                                            }
                                            notesNotification={
                                              detailsActiveTab[index]
                                                ?.notesNotification
                                            }
                                            internalNotesNotification={
                                              detailsActiveTab[index]
                                                ?.internalNotesNotification
                                            }
                                            onChange={(value) => {
                                              let newTab = [
                                                ...detailsActiveTab,
                                              ];
                                              const data = {
                                                type:
                                                  value === 'internal-notes'
                                                    ? 'internalNotes'
                                                    : value,
                                                issueId: _id,
                                              };
                                              if (
                                                !isClient() &&
                                                ((value === 'notes' &&
                                                  newTab[index]
                                                    .notesNotification) ||
                                                  (value === 'internal-notes' &&
                                                    newTab[index]
                                                      .internalNotesNotification))
                                              ) {
                                                props.markAllIssuesNotesRead(
                                                  data,
                                                  onError
                                                );
                                              }
                                              newTab[index].key = value;
                                              if (value === 'notes')
                                                newTab[
                                                  index
                                                ].notesNotification = false;
                                              if (value === 'internal-notes')
                                                newTab[
                                                  index
                                                ].internalNotesNotification = false;
                                              setDetailsActiveTab(newTab);
                                            }}
                                            tabIndex={index}
                                          />
                                          {detailsActiveTab[index]?.key ===
                                            'notes' && (
                                            <>
                                              {notes?.map((item, index) => (
                                                <NotesDataList
                                                  data={item.note}
                                                  createdBy={item.createdBy}
                                                  createdAt={item.createdAt}
                                                  isBottomBorder={
                                                    notes?.length !== index + 1
                                                  }
                                                  onEditClick={() => {
                                                    setAddNoteDialog(true);
                                                    setSelectedNote({
                                                      ...item,
                                                      issueId: _id,
                                                      isInternalNote: false,
                                                    });
                                                    setIsEditIssueNote(true);
                                                    setSelectedNoteId(
                                                      item?._id
                                                    );
                                                    setSelectedIssueId(_id);
                                                  }}
                                                  onDeleteClick={() => {
                                                    onDeleteIssueNoteClick(
                                                      _id,
                                                      item?._id,
                                                      'notes'
                                                    );
                                                  }}
                                                  showLoader={
                                                    props?.deleteIssueNoteLoading &&
                                                    selectedNoteId === item?._id
                                                  }
                                                />
                                              ))}
                                            </>
                                          )}
                                          {detailsActiveTab[index]?.key ===
                                            'details' && (
                                            <>
                                              <NotesDataList
                                                data={description}
                                              />
                                              {createdBy && createdBy.name && (
                                                <NotesDataList
                                                  data={`${Strings.REPORTED_BY} ${createdBy?.name}`}
                                                  style={{ marginTop: 15 }}
                                                />
                                              )}
                                            </>
                                          )}
                                          {detailsActiveTab[index]?.key ===
                                            'media' && (
                                            <>
                                              {attachments &&
                                                attachments.length > 0 && (
                                                  <div>
                                                    <MediaImageContainer
                                                      imageArray={attachments}
                                                      itemsPerRow={
                                                        mobileView
                                                          ? 2
                                                          : tabletView
                                                          ? 3
                                                          : laptopView
                                                          ? 4
                                                          : 5
                                                      }
                                                    />
                                                  </div>
                                                )}
                                            </>
                                          )}
                                          {detailsActiveTab[index]?.key ===
                                            'internal-notes' &&
                                            (isAdmin() || isSuperAdmin()) && (
                                              <>
                                                {internalNotes?.map(
                                                  (item, index) => (
                                                    <NotesDataList
                                                      data={item.note}
                                                      createdBy={item.createdBy}
                                                      createdAt={item.createdAt}
                                                      isBottomBorder={
                                                        notes?.length !==
                                                        index + 1
                                                      }
                                                      onEditClick={() => {
                                                        setAddNoteDialog(true);
                                                        setSelectedNote({
                                                          ...item,
                                                          issueId: _id,
                                                          isInternalNote: true,
                                                        });
                                                        setIsEditIssueNote(
                                                          true
                                                        );
                                                        setSelectedNoteId(
                                                          item?._id
                                                        );
                                                        setSelectedIssueId(_id);
                                                      }}
                                                      onDeleteClick={() => {
                                                        onDeleteIssueNoteClick(
                                                          _id,
                                                          item?._id,
                                                          'internalNotes'
                                                        );
                                                      }}
                                                      showLoader={
                                                        props?.deleteIssueNoteLoading &&
                                                        selectedNoteId ===
                                                          item?._id
                                                      }
                                                    />
                                                  )
                                                )}
                                              </>
                                            )}
                                          {detailsActiveTab[index]?.key ===
                                            'related-jobs' && (
                                            <>
                                              {linkedJobs?.map((item) => {
                                                return (
                                                  <div
                                                    className={
                                                      classes.relatedJob_container
                                                    }
                                                  >
                                                    <p
                                                      className={
                                                        classes.note_data
                                                      }
                                                      style={{
                                                        border: 0,
                                                        width: '30%',
                                                      }}
                                                    >
                                                      {item.title}
                                                    </p>
                                                    {item?.report && (
                                                      <Button
                                                        text={
                                                          Strings.VIEW_REPORT
                                                        }
                                                        className={
                                                          classes.button
                                                        }
                                                        loaderColor={
                                                          theme.palette
                                                            .background_button_text
                                                        }
                                                        onClick={() => {
                                                          navigate(
                                                            '/app/report',
                                                            {
                                                              state: {
                                                                jobId: item._id,
                                                              },
                                                            }
                                                          );
                                                        }}
                                                      />
                                                    )}
                                                  </div>
                                                );
                                              })}
                                            </>
                                          )}
                                          {detailsActiveTab[index]?.key ===
                                            'supplies' && (
                                            <>
                                              <NotesDataList
                                                data={suppliesNeeded}
                                              />
                                            </>
                                          )}
                                        </Stack>
                                        {!isClient() && (
                                          <Hidden smUp>
                                            <Stack
                                              paddingTop={0.5}
                                              direction='column'
                                              alignItems='flex-start'
                                            >
                                              <ActionButton
                                                text={Strings.ACTIONS}
                                                onClick={() =>
                                                  setDrawerOpen(true)
                                                }
                                              />
                                            </Stack>
                                            <ActionDrawer
                                              id={_id}
                                              onClose={() =>
                                                setDrawerOpen(false)
                                              }
                                              open={drawerOpen}
                                              onSelect={(action, id) => {
                                                handleOnAction(
                                                  action,
                                                  id,
                                                  client,
                                                  issueTitle,
                                                  data
                                                );
                                                setDrawerOpen(false);
                                              }}
                                              status={status}
                                            />
                                          </Hidden>
                                        )}
                                      </Grid>
                                      {!isClient() && (
                                        <Hidden smDown>
                                          <Grid item xs={2}>
                                            <Stack
                                              flexDirection='row'
                                              justifyContent='flex-end'
                                            >
                                              <ActionMenu
                                                id={_id}
                                                onSelect={(action, id) =>
                                                  handleOnAction(
                                                    action,
                                                    id,
                                                    client,
                                                    issueTitle,
                                                    data
                                                  )
                                                }
                                                status={status}
                                              />
                                            </Stack>
                                          </Grid>
                                        </Hidden>
                                      )}
                                    </Grid>
                                  </TableCell>
                                </TableRow>
                              </>
                            )}
                          </>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </>
        )}
      </div>
      {newIssueDialog && !isClient() && (
        <NewIssue
          isEdit={isEdit}
          data={selectedIssue}
          onClose={() => {
            setIsEdit(false);
            setNewIssueDialog(false);
          }}
        />
      )}
      {filterDialog && (
        <IssuesFilter
          setFilterData={setFilterData}
          filterData={filter}
          setIsFilterChange={setIsFilterChange}
          onClose={() => setFilterDialog(false)}
        />
      )}
      {assignUserDialog && !isClient() && (
        <AssignUserDialog
          selectedIssueId={selectedIssueId}
          onNewClose={() => setAssignUserDialog(false)}
        />
      )}
      {deleteIssueDialog && !isClient() && (
        <CommonDialog
          title={Strings.ISSUES}
          message={Strings.DELETE_ISSUE}
          onSuccess={() => onDeleteIssue()}
          onClose={() => setDeleteIssueDialog(false)}
          loading={props.deleteIssueLoading}
        />
      )}
      {addNoteDialog && (
        <AddNotes
          selectedId={selectedIssueId}
          onNewClose={() => {
            setAddNoteDialog(false);
            setIsClientDirective({});
            setSelectedNote(null);
            setIsEditIssueNote(false);
          }}
          isEditIssueNote={isEditIssueNote}
          selectedNote={selectedNote}
          isClientDirective={
            Object.keys(isClientDirective).length > 0
              ? isClientDirective
              : false
          } // used for request client directive action
          updateIssueByPerformAction={props.updateIssueByPerformAction}
        />
      )}
      {addJobDialog && !isClient() && (
        <NewJob
          issue
          data={selectedJob}
          onNewClose={() => {
            setAddJobDialog(false);
          }}
        />
      )}
      {openSendReportDialog && (
        <SendReport
          onNewClose={() => setOpenSendReportDialog(false)}
          isIssueUpdate
          selectedIssueId={selectedIssueId}
          client={selectedIssueClient}
        />
      )}
      {openEditFilterDialog?.show && (
        <IssuesNewFilter
          isEdit={true}
          setIsFilterChange={setIsFilterChange}
          selectedId={openEditFilterDialog?.value}
          onClose={() => setOpenEditFilterDialog()}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  issueListData: state.issueListData.data,
  issueListLoading: state.issueListData.loading,

  addIssueData: state.addIssueData.data,

  deleteIssueLoading: state.deleteIssueData.loading,
  deleteIssueData: state.deleteIssueData.data,

  updateIssueData: state.updateIssueData.data,

  updateIssueByActionData: state.updateIssueByActionData.data,

  addIssueNoteData: state.addIssueNoteData.data,

  visibleIssueData: state.visibleIssueData.data,
  visibleIssueLoading: state.visibleIssueData.loading,

  updateIssueNoteData: state.updateIssueNoteData.data,

  deleteIssueNoteLoading: state.deleteIssueNoteData.loading,

  listFilterData: state.listFilterData.data,
  listFilterLoading: state.listFilterData.loading,

  addFilterData: state.addFilterData.data,
  updateFilterData: state.updateFilterData.data,
  deleteFilterData: state.deleteFilterData.data,

  exportIssuesLoading: state.exportIssuesData.loading,
});

export default connect(mapStateToProps, {
  fetchIssueList,
  deleteIssue,
  updateIssueByPerformAction,
  visibleIssue,
  sendUpdate,
  deleteIssueNote,
  clientDirectiveReminder,
  listFilter,
  markAllIssuesNotesRead,
  exportIssues,
})(Issues);
